import { useState } from 'react';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  SectionLayout,
  SectionLayoutSkeleton,
} from '@/components/ui/SectionLayout.tsx';
import NoItems from '@/components/ui/NoItems.tsx';
import useGetCashInstruction from '@/features/dashboard/paymentConfig/hooks/useGetCashInstruction.ts';
import EditCashInstructionModal from '@/features/dashboard/paymentConfig/components/EditCashInstructionModal.tsx';
import RichTextPreview from '@/components/richText/RichTextPreview.tsx';

const CashInstructionSection = () => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { data, isLoading } = useGetCashInstruction();

  if (isLoading) {
    return <SectionLayoutSkeleton rows={1} />;
  }

  const hasInstruction = !!data?.instruction;

  return (
    <>
      <SectionLayout
        title="Płatności gotówką"
        description="Gotówka jest w Campdesk włączona na stałe. Możesz dodać instrukcję, którą zobaczą osoby wybierające tę formę płatności."
      >
        {hasInstruction ? (
          <div className="flex items-start gap-3 rounded-[10px] border border-neutral-200 px-4 py-3.5 text-neutral-800">
            <RichTextPreview
              html={data.instruction}
              className="min-w-0 flex-1"
              /*
               * `.cd-doc` jedzie nieowarstwionym arkuszem dokumentu, więc bije
               * każdą klasę Tailwinda (te siedzą w warstwie) niezależnie od
               * specyficzności. Styl inline to jedyne wejście przewidziane
               * kontraktem — stąd rozmiar tutaj, a barwa dziedziczona z ramki.
               */
              style={{ fontSize: '13.5px', lineHeight: 1.6, color: 'inherit' }}
            />
            <ActionButton
              tone="outline"
              size="toolbar"
              onClick={() => setIsEditModalOpen(true)}
            >
              Zmień
            </ActionButton>
          </div>
        ) : (
          <NoItems
            title="Brak instrukcji"
            description="Dodaj instrukcję płatności gotówką, która będzie widoczna dla uczestników."
          >
            <ActionButton
              tone="outline"
              size="toolbar"
              onClick={() => setIsEditModalOpen(true)}
            >
              Dodaj instrukcję
            </ActionButton>
          </NoItems>
        )}
      </SectionLayout>
      {isEditModalOpen && (
        <EditCashInstructionModal
          currentInstruction={data?.instruction ?? ''}
          onClose={() => setIsEditModalOpen(false)}
        />
      )}
    </>
  );
};

export default CashInstructionSection;
